import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonItem,
  IonSelect,
  IonLabel,
  IonSelectOption,
} from "@ionic/react";
import Peep from "react-peeps";
import "./Tab1.css";

const styles = {
  peepStyle: {
    width: 300,
    height: 300,
    justifyContent: "center",
  },
  showcaseWrapper: {
    display: "flex",
    justifyContent: "center",
  },
};

const peepOptions = {
  accessory: [
    "None",
    "Eyepatch",
    "GlassRoundThick",
    "SunglassClubmaster",
    "SunglassWayfarer",
    "GlassAviator",
    "GlassButterfly",
    "GlassButterflyOutline",
    "GlassClubmaster",
    "GlassRound",
  ],
  body: [
    "BlazerBlackTee",
    "Shirt",
    "ButtonShirt",
    "Dress",
    "Gaming",
    "Geek",
    "Hoodie",
    "PointingUp",
    "Selena",
    "Thunder",
    "Turtleneck",
    "ArmsCrossed",
    "Coffee",
    "Device",
    "DotJacket",
    "Explaining",
    "FurJacket",
    "Killer",
    "Paper",
    "PocketShirt",
    "PoloSweater",
    "ShirtCoat",
    "ShirtFilled",
    "SportyShirt",
    "StripedShirt",
    "Sweater",
    "SweaterDots",
    "Whatever",
    "Bike",
    "ClosedLegBW",
    "ClosedLegWB",
    "CrossedLegs",
    "HandsBackBW",
    "HandsBackWB",
    "MediumBW",
    "MediumWB",
    "OneLegUpBW",
    "OneLegUpWB",
    "WheelChair",
    "BlazerBW",
    "BlazerPantsBW",
    "BlazerPantsWB",
    "BlazerWB",
    "CrossedArmsBW",
    "CrossedArmsWB",
    "EasingBW",
    "EasingWB",
    "PointingFingerBW",
    "PointingFingerWB",
    "PolkaDots",
    "RestingBW",
    "RestingWB",
    "RoboDanceBW",
    "RoboDanceOutline",
    "RoboDanceWB",
    "ShirtBW",
    "ShirtPantsBW",
    "ShirtPantsWB",
    "ShirtWB",
    "WalkingBW",
    "WalkingFilled",
    "WalkingWB",
    "Doc",
    "DocProtectiveClothe",
    "DocStethoscope",
  ],
  face: [
    "Angry",
    "Blank",
    "Calm",
    "Cheeky",
    "Concerned",
    "Contempt",
    "Cute",
    "Driven",
    "EatingHappy",
    "EyesClosed",
    "OldAged",
    "Serious",
    "Smile",
    "Solemn",
    "Suspicious",
    "Tired",
    "VeryAngry",
    "Awe",
    "ConcernedFear",
    "Cyclops",
    "Explaining",
    "Fear",
    "Hectic",
    "LoveGrin",
    "LoveGrinTeeth",
    "Monster",
    "Rage",
    "SmileBig",
    "SmileLol",
    "SmileTeeth",
    "CalmNM",
    "SmileNM",
    "CheersNM",
  ],
  facialHair: [
    "None",
    "Chin",
    "Full",
    "FullMajestic",
    "FullMedium",
    "Goatee",
    "GoateeCircle",
    "Dali",
    "Handlebars",
    "Imperial",
    "Painters",
    "PaintersFilled",
    "Swashbuckler",
    "MoustacheThin",
    "Yosemite",
    "GrayFull",
    "MajesticHandlebars",
  ],
  hair: [
    "Afro",
    "Bald",
    "BaldSides",
    "BaldTop",
    "Bangs",
    "BangsFilled",
    "Bear",
    "Bun",
    "BunCurly",
    "Buns",
    "FlatTop",
    "FlatTopLong",
    "HatHip",
    "Long",
    "LongAfro",
    "LongBangs",
    "LongCurly",
    "Medium",
    "MediumBangs",
    "MediumBangsFilled",
    "MediumLong",
    "MediumShort",
    "MediumStraight",
    "Mohawk",
    "MohawkDino",
    "Pomp",
    "ShavedRight",
    "ShavedSides",
    "ShavedWavy",
    "Short",
    "ShortCurly",
    "ShortMessy",
    "ShortScratch",
    "ShortVolumed",
    "ShortWavy",
    "BantuKnots",
    "Beanie",
    "BunFancy",
    "CornRows",
    "CornRowsFilled",
    "GrayBun",
    "GrayMedium",
    "GrayShort",
    "Hijab",
    "MediumShade",
    "Turban",
    "Twists",
    "TwistsVolumed",
    "DocBouffant",
    "DocSurgery",
    "DocShield",
  ],
};

const hasEnoughGold = (gold) => {
  return gold >= 50;
};

const Tab1: React.FC<{
  gold: number;
  peepConfig: {};
  updatePeepConfig: (key: string, value: string) => void;
}> = ({ gold, peepConfig, updatePeepConfig }) => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Shop</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Shop</IonTitle>
          </IonToolbar>
        </IonHeader>
        <div style={styles.showcaseWrapper}>
          <Peep
            style={styles.peepStyle}
            accessory={peepConfig["accessory"]}
            body={peepConfig["body"]}
            face={peepConfig["face"]}
            hair={peepConfig["hair"]}
            facialHair={peepConfig["facialHair"]}
          />
        </div>

        <IonItem class="ion-text-center">
          <IonLabel>{gold} gold</IonLabel>
        </IonItem>

        <IonItem lines="none">
          <IonLabel>Hair (50 gold)</IonLabel>
          <IonSelect
            value={peepConfig["hair"]}
            onIonChange={(e) => updatePeepConfig("hair", e.detail.value)}
            disabled={!hasEnoughGold(gold)}
          >
            {peepOptions.hair.map((item, index) => (
              <IonSelectOption key={index} value={item}>
                {item}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonItem>

        <IonItem lines="none">
          <IonLabel>Accessory (50 gold)</IonLabel>
          <IonSelect
            value={peepConfig["accessory"]}
            onIonChange={(e) => updatePeepConfig("accessory", e.detail.value)}
            disabled={!hasEnoughGold(gold)}
          >
            {peepOptions.accessory.map((item, index) => (
              <IonSelectOption key={index} value={item}>
                {item}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonItem>

        <IonItem lines="none">
          <IonLabel>Face (50 gold)</IonLabel>
          <IonSelect
            value={peepConfig["face"]}
            onIonChange={(e) => updatePeepConfig("face", e.detail.value)}
            disabled={!hasEnoughGold(gold)}
          >
            {peepOptions.face.map((item, index) => (
              <IonSelectOption key={index} value={item}>
                {item}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonItem>

        <IonItem lines="none">
          <IonLabel>Facial Hair (50 gold)</IonLabel>
          <IonSelect
            value={peepConfig["facialHair"]}
            onIonChange={(e) => updatePeepConfig("facialHair", e.detail.value)}
            disabled={!hasEnoughGold(gold)}
          >
            {peepOptions.facialHair.map((item, index) => (
              <IonSelectOption key={index} value={item}>
                {item}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonItem>

        <IonItem lines="none">
          <IonLabel>Body (50 gold)</IonLabel>
          <IonSelect
            value={peepConfig["body"]}
            onIonChange={(e) => updatePeepConfig("body", e.detail.value)}
            disabled={!hasEnoughGold(gold)}
          >
            {peepOptions.body.map((item, index) => (
              <IonSelectOption key={index} value={item}>
                {item}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonItem>
      </IonContent>
    </IonPage>
  );
};

export default Tab1;
